module.exports = __webpack_public_path__ + "img/pic_sp_mrt.4ad70498.png";